let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e50ls")).then(() => parcelRequire('7IdUx'));